var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', [_c('div', {
    staticClass: "container-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "header-back-link",
    attrs: {
      "title": _vm.$t('common.back')
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'cabinet'
        });
      }
    }
  }), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-label"
  }, [_vm._v(_vm._s(_vm.$t('self.employed.turned.on')))]), _c('div', {
    staticClass: "header-title",
    attrs: {
      "data-private": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('inn.with.colon')) + " " + _vm._s(_vm.displayInnSelfEmployed) + " ")])]), _c('div', {
    staticClass: "button-link",
    on: {
      "click": _vm.handleAutoDeclarationConnectShown
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('turn.off')) + " ")])]), _c('div', {
    staticClass: "content"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.autodeclaration')))]), _vm._l(_vm.preparedProjects, function (project) {
    return _c('div', {
      key: project.projectId,
      staticClass: "auto-declaration-list"
    }, [_c('toggle-panel', {
      attrs: {
        "title": project.name,
        "value": project.autoDeclaration
      },
      on: {
        "click": function click($event) {
          return _vm.handleChangeAutoDeclaration(project);
        }
      }
    }, [_c('project-logo', {
      attrs: {
        "slot": "icon",
        "project": project
      },
      slot: "icon"
    }), _c('capusta-input', {
      attrs: {
        "slot": "content",
        "label": _vm.$t('product.description.default'),
        "value": project.declarationDescription,
        "disabled": ""
      },
      slot: "content"
    }, [_c('span', {
      staticClass: "auto-declaration-link",
      attrs: {
        "slot": "link"
      },
      on: {
        "click": function click($event) {
          return _vm.handleDeclarationSettingsShown(project);
        }
      },
      slot: "link"
    }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])])], 1)], 1);
  })], 2)], 1)]), _c('UnbindSelfEmployedModal', {
    on: {
      "unbind": _vm.handleUnbindSelfEmployed
    },
    model: {
      value: _vm.isAutoDeclarationConnectShown,
      callback: function callback($$v) {
        _vm.isAutoDeclarationConnectShown = $$v;
      },
      expression: "isAutoDeclarationConnectShown"
    }
  }), _c('AutoDeclarationSettingsModal', {
    attrs: {
      "project": _vm.selectedProject
    },
    on: {
      "change": _vm.handleAutoDeclarationSettings
    },
    model: {
      value: _vm.isDeclarationSettingsShown,
      callback: function callback($$v) {
        _vm.isDeclarationSettingsShown = $$v;
      },
      expression: "isDeclarationSettingsShown"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }